import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { RoleRow } from "./use-roles";

// GET /api/settings/roles/:id — single role + its permissions.
export function useRole(id: string | undefined) {
  return useQuery<RoleRow, ApiClientError>({
    queryKey: queryKeys.settings.role(id ?? ""),
    queryFn: () => apiFetch<RoleRow>(`/settings/roles/${id}`),
    enabled: !!id,
  });
}
